import { Gender } from '../modules/info/config/info.config';

const config = {
  user: {
    company: 'Société 42',
    firstName: 'Thomas',
    lastName: 'Nova',
    gender: Gender.MALE,
  },
};

export default config;
